import type { CSSProperties, ReactNode } from "react";

type RuntimeSquareSizeAttributes = { style: CSSProperties };

type RuntimeSquareSizeProps = {
  size: number;
  children: (attributes: RuntimeSquareSizeAttributes) => ReactNode;
};

/** Applies equal runtime dimensions required by caller-sized chart renderers. */
export function RuntimeSquareSize({ size, children }: RuntimeSquareSizeProps): ReactNode {
  return children({ style: { width: size, height: size } });
}
